import Vue from 'vue'

let $alarm = {
  build () {
    let notice = require('./notice.mp3')
    let s = `
      <div style="display: none">
        <video id="alarm-notice"><source src="${notice}" type="audio/mpeg"></video>
      </div>`
    let el = document.getElementById('alarm-notice')
    if (!el) {
      document.body.insertAdjacentHTML('beforeend', s)
    }
  },
  play () {
    document.getElementById(`alarm-notice`).play()
  }
}
$alarm.build()
Vue.prototype.$alarm = $alarm
